export default "__VITE_ASSET__CysmxU7J__"